import React, { useEffect, useLayoutEffect, useRef } from "react";
import Flagmans from "../components/Flagmans";
import History from "../components/History";
import Main from "../components/Main";
import Products from "../components/Products";
import SplitterImage from "../components/SplitImage";
import Footer from "../components/Footer";
import BuyBlock from "../components/BuyBlock";
import Navigation from "../components/Navigation";
import airGoldLogo from "../images/airGoldLogo.svg";
import airGoldBlured from "../images/airGoldBlured.png";
import { checkAndSetStats } from "../helpers/helpers";
import SEO from "../components/SEO";

function AirGold() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#1D1D1D";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("airGoldPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <SEO
                title="Колекція Air Gold"
                description="Air Gold — елегантна колекція золотих прикрас від TSATSKY. Вишукані каблучки, сережки та підвіски з золота 585 проби ручної роботи."
                url="/air-gold"
                collection={{ name: "Air Gold", description: "Елегантна колекція золотих прикрас" }}
            />
            <Navigation showBack backTo="/" variant="dark" />
            <div className="main_wrapper">
                <Main
                    path="airGold"
                    logoImage={airGoldLogo}
                    logoAlt="Air Gold Logo"
                    defaultImage={airGoldBlured}
                />
            </div>

            <div>
                <History path="airGold" defaultImage={airGoldBlured} />
                <SplitterImage />

                <Flagmans />
                <Products
                    priceStyles={"text-custom-yellow"}
                    path="airGold"
                    defaultImage={airGoldBlured}
                />

                <BuyBlock />
                <Footer />
            </div>
        </div>
    );
}

export default AirGold;
